import { createModel } from '@rematch/core';
import { countriesService } from 'src/config/rootService';
import { RootModel } from 'src/config/rootStore';

import { Country } from '../models/country';

export type CountryState = Country[] | null; // null is used as a isFetching flag

const defaultState = null as CountryState;

export const countries = createModel<RootModel>()({
    state: defaultState,
    reducers: {
        saveCountries: (_state, payload: Country[] = []): CountryState => payload,
    },
    effects: dispatch => ({
        async fetchCountries(): Promise<void> {
            const countriesData = await countriesService.fetchCountries();
            if (countriesData) {
                countriesData.forEach(country => {
                    country.value = country.name;
                    country.text = country.displayName;
                    // West Bank and Gaza Strip region uses Palestine (PS) for their flag, therefore
                    // we need to override their iso-code
                    if (country.isoCode === 'PS-IL' || country.isoCode === 'PS-GZA') {
                        country.isoCode = 'PS';
                    }
                });

                dispatch.countries.saveCountries(countriesData);
            }
        },
    }),
});
